import {
  Avatar,
  Box,
  Card,
  CardContent,
  colors,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { User as UserIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import DoctorSelector from 'src/components/Doctors/DoctorSelector';

const useStyles = makeStyles({
  root: {
    height: '100%',
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56,
  },
});

const DoctorPicker = ({ className, ...rest }) => {
  const classes = useStyles();
  const { t } = useTranslation('users');

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              {t('labels.doctor').toUpperCase()}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <UserIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <DoctorSelector />
        </Grid>
        <Box mt={2} display="flex" alignItems="center">
          <Typography color="textSecondary" variant="body1">
            {t('texts.doctor_selector')}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

DoctorPicker.propTypes = {
  className: PropTypes.string,
};

export default DoctorPicker;
